import { useEffect, useMemo, useState } from 'react';
import './StorePage.css';
import categoryGeneralPNG from '../images/store/category-general.png';
import bond5PNG from '../images/store/bond-5.png';
import bond10PNG from '../images/store/bond-10.png';
import bond25PNG from '../images/store/bond-25.png';
import bond50PNG from '../images/store/bond-50.png';
import bond100PNG from '../images/store/bond-100.png';
import extraSvg from '../images/store/extra-svg.svg';
import trophy1stSVG from '../images/store/trophy-1st.svg';
import trophy2ndSVG from '../images/store/trophy-2nd.svg';
import trophy3rdSVG from '../images/store/trophy-3rd.svg';
import rank1PNG from '../images/store/rank-1.png';
import rank2PNG from '../images/store/rank-2.png';
import rank3PNG from '../images/store/rank-3.png';
import rank4PNG from '../images/store/rank-4.png';
import rank5PNG from '../images/store/rank-5.png';
import rank6PNG from '../images/store/rank-6.png';
import rank7PNG from '../images/store/rank-7.png';
import rank8PNG from '../images/store/rank-8.png';
import ReasonNav from '../components/reason/ReasonNav';
import ReasonFooter from '../components/reason/ReasonFooter';

const PRODUCTS = [
  { id: 'bond-5', name: 'Treason $5 Bond', price: 5, image: bond5PNG },
  { id: 'bond-10', name: 'Treason $10 Bond ', price: 10, image: bond10PNG },
  { id: 'bond-25', name: 'Treason $25 Bond', price: 25, image: bond25PNG, badge: 'Extra 20% Points' },
  { id: 'bond-50', name: 'Treason $50 Bond', price: 50, image: bond50PNG, badge: 'Extra 20% Points' },
  { id: 'bond-100', name: 'Treason $100 Bond', price: 100, image: bond100PNG, badge: 'Extra 25% Points' },
];

const DONATOR_RANKS = [
  { amount: '$10 Donated:', label: 'Donator', color: '#E50000', icon: rank1PNG },
  { amount: '$50 Donated:', label: 'Super Donator', color: '#0094FF', icon: rank2PNG },
  { amount: '$100 Donated:', label: 'Elite Donator', color: '#00FD8F', icon: rank3PNG },
  { amount: '$250 Donated:', label: 'Noble Donator', color: '#7F6A00', icon: rank4PNG },
  { amount: '$500 Donated:', label: 'Gold Donator', color: '#FDD600', icon: rank5PNG },
  { amount: '$1,000 Donated:', label: 'Platinum Donator', color: '#404040', icon: rank6PNG },
  { amount: '$2,500 Donated:', label: 'Legendary Donator', color: '#B200FF', icon: rank7PNG },
  { amount: '$5,000 Donated:', label: 'Supreme Donator', color: '#FF6A00', icon: rank8PNG },
];

const TOP_DONATORS = [
  { rank: 1, username: 'rg a' },
  { rank: 2, username: 'cranck' },
  { rank: 3, username: 'freshworld' },
  { rank: 4, username: 'bang bang' },
  { rank: 5, username: 'milfslayer13' },
  { rank: 6, username: 'topmaniron' },
  { rank: 7, username: 'gim edo' },
  { rank: 8, username: 'shutyouout' },
  { rank: 9, username: 'gimpower' },
  { rank: 10, username: 'wednesday' },
];

function currentMonthLabel() {
  const labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return labels[new Date().getUTCMonth()];
}

function formatPrice(amount) {
  return `$${amount.toFixed(2)}`;
}

function trophyForRank(rank) {
  if (rank === 1) return trophy1stSVG;
  if (rank === 2) return trophy2ndSVG;
  if (rank === 3) return trophy3rdSVG;
  return null;
}

function StorePage() {
  const [cart, setCart] = useState([]);
  const [username, setUsername] = useState('');
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [checkoutError, setCheckoutError] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  const cartTotal = useMemo(
    () => cart.reduce((sum, item) => sum + item.price * item.qty, 0),
    [cart],
  );

  useEffect(() => {
    const root = document.getElementById('root');
    const prevRootBg = root?.style.backgroundColor;
    if (root) root.style.backgroundColor = '#111013';
    return () => {
      document.body.style.overflow = '';
      if (root) root.style.backgroundColor = prevRootBg || '';
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
  }, [menuOpen]);

  function addToCart(product) {
    setCart((prev) => {
      const existing = prev.find((item) => item.id === product.id);
      if (existing) {
        return prev.map((item) =>
          item.id === product.id ? { ...item, qty: item.qty + 1 } : item,
        );
      }
      return [...prev, { ...product, qty: 1 }];
    });
    setCheckoutError('');
  }

  function incrementQty(id) {
    setCart((prev) =>
      prev.map((item) => (item.id === id ? { ...item, qty: item.qty + 1 } : item)),
    );
    setCheckoutError('');
  }

  function decrementQty(id) {
    setCart((prev) =>
      prev
        .map((item) => (item.id === id ? { ...item, qty: item.qty - 1 } : item))
        .filter((item) => item.qty > 0),
    );
    setCheckoutError('');
  }

  function handleCheckout() {
    if (cart.length === 0) {
      setCheckoutError('Your cart is empty.');
      return;
    }
    if (!username.trim()) {
      setCheckoutError('Please enter your in-game username.');
      return;
    }
    if (!agreedToTerms) {
      setCheckoutError('You must agree to the terms and conditions.');
      return;
    }
    window.alert('Checkout is not connected yet.');
  }

  return (
    <div className={`reason-page store-page${menuOpen ? ' menu-open' : ''}`}>
      <ReasonNav activePage="store" menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      <div className="container mx-auto vote-body">
        <h2>Store</h2>
      </div>

      <div className="container mx-auto store-container">
        <div className="row">
          <div className="col-md-8" style={{ padding: 0 }}>
            <StoreCategories />
            <p className="secondary-title">General</p>
            <StoreProducts onAddToCart={addToCart} />
          </div>

          <div className="col-md-4" style={{ paddingRight: 0 }}>
            <StoreCart
              cart={cart}
              cartTotal={cartTotal}
              username={username}
              setUsername={setUsername}
              agreedToTerms={agreedToTerms}
              setAgreedToTerms={setAgreedToTerms}
              checkoutError={checkoutError}
              onIncrement={incrementQty}
              onDecrement={decrementQty}
              onCheckout={handleCheckout}
            />
            <DonatorRanks />
            <TopDonators />
          </div>
        </div>
      </div>

      <ReasonFooter />
    </div>
  );
}

function StoreCategories() {
  return (
    <div className="categories">
      <div className="category active">
        <img className="image" src={categoryGeneralPNG} alt="General" />
        <p className="title">General</p>
      </div>
    </div>
  );
}

function StoreProducts({ onAddToCart }) {
  return (
    <div className="store-products row">
      {PRODUCTS.map((product) => (
        <div key={product.id} className="col-lg-4">
          <div className="product">
            <div className="main-container">
              {product.badge && (
                <div className="extra-tag">
                  <img src={extraSvg} className="icon" alt="" />
                  {product.badge}
                </div>
              )}
              <img src={product.image} alt={product.name} className="product-image" />
              <p className="product-title">{product.name}</p>
              <div className="price">{formatPrice(product.price)}</div>
              <button
                type="button"
                className="button secondary"
                onClick={() => onAddToCart(product)}
              >
                Add To Cart
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function StoreCart({
  cart,
  cartTotal,
  username,
  setUsername,
  agreedToTerms,
  setAgreedToTerms,
  checkoutError,
  onIncrement,
  onDecrement,
  onCheckout,
}) {
  const hasItems = cart.length > 0;

  return (
    <div className="secondary-container">
      <p className="secondary-title">Cart</p>

      {hasItems ? (
        <>
          <div id="basket-items">
            {cart.map((item) => (
              <div key={item.id} className="cart-item">
                <div className="image">
                  <img src={item.image} alt="" />
                </div>
                <div className="details">
                  <p className="title">{item.name}</p>
                  <div className="actions">
                    <button
                      type="button"
                      className="small-button"
                      onClick={() => onDecrement(item.id)}
                      aria-label="Decrease quantity"
                    >
                      -
                    </button>
                    <span className="quantity">{item.qty}</span>
                    <button
                      type="button"
                      className="small-button"
                      onClick={() => onIncrement(item.id)}
                      aria-label="Increase quantity"
                    >
                      +
                    </button>
                  </div>
                </div>
                <div className="price">{formatPrice(item.price * item.qty)}</div>
              </div>
            ))}
          </div>

          <p className="cart-total">
            Cart total: <span className="username">{formatPrice(cartTotal)}</span>
          </p>
        </>
      ) : (
        <p className="secondary-text">There are currently no items in your basket</p>
      )}

      <div className="username-checkout-container">
        <div className="username-box">
          <div className="form-group">
            <input
              className="form-control"
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <small className="form-text">
              Please ensure you enter the correct username
            </small>
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="agree-terms-conditions"
              checked={agreedToTerms}
              onChange={(e) => setAgreedToTerms(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="agree-terms-conditions">
              Agree to the terms and conditions
            </label>
          </div>
        </div>
        {checkoutError && <p className="checkout-error">{checkoutError}</p>}
        <button
          type="button"
          className="button"
          style={{ width: '100%' }}
          onClick={onCheckout}
        >
          Proceed To Checkout
        </button>
      </div>
    </div>
  );
}

function DonatorRanks() {
  return (
    <div className="secondary-container">
      <p className="secondary-title">Treason Ranks</p>
      <p className="secondary-text" style={{ marginBottom: '10px' }}>
        Help Support Development and Unlock Benefits
      </p>
      <div className="ranks">
        {DONATOR_RANKS.map((rank) => (
          <div key={rank.label} className="rank-benefit">
            <div className="amount-donated">{rank.amount}</div>
            <div className="rank-type">
              <img src={rank.icon} alt="" />
              <span style={{ color: rank.color, fontWeight: 'bold' }}>{rank.label}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function TopDonators() {
  const month = currentMonthLabel();
  const year = String(new Date().getUTCFullYear()).slice(-2);

  return (
    <div className="secondary-container">
      <p className="secondary-title">Top Donators</p>
      <p className="secondary-text" style={{ marginBottom: '10px' }}>
        ({month}, {year})
      </p>
      {TOP_DONATORS.map((donor) => {
        const trophy = trophyForRank(donor.rank);
        const rankClass = donor.rank <= 3 ? ` rank-${donor.rank}` : '';
        return (
          <div key={donor.rank} className={`rank-benefit top-donor${rankClass}`}>
            <div>
              {trophy && <img src={trophy} alt="" />}
              {donor.rank}. {donor.username}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default StorePage;
